module.exports = __webpack_public_path__ + "images/emoji/blue_heart.07d97f89bca9a1d0c9dd.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/blue_heart.png
// module id = j9DX
// module chunks = 1